/**
 * The one shape every step of the review is offered in: a quiet row that states what is
 * available and the single button that takes it. Nothing on this path starts on its own.
 */

import type { LucideIcon } from 'lucide-react';
import { PillButton } from '../ui/pill-button';

interface ReviewInviteProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action: string;
  onAction: () => void;
}

export const ReviewInvite = ({ icon: Icon, title, description, action, onAction }: ReviewInviteProps) => (
  <div className='flex items-center gap-3 rounded-xl border border-dashed border-gray-500 bg-gray-50/60 px-3.5 py-2.5 animate-in fade-in-0 slide-in-from-bottom-1 duration-300 ease-out'>
    <span className='flex size-7 shrink-0 items-center justify-center rounded-full bg-white ring-1 ring-gray-500'>
      <Icon className='size-3.5 text-text-body' aria-hidden />
    </span>
    <div className='flex min-w-0 flex-1 flex-col'>
      <p className='text-[13px] leading-4.5 font-medium text-text-body'>{title}</p>
      {description && <p className='text-xs leading-4 text-gray-800'>{description}</p>}
    </div>
    <PillButton variant='primary' className='shrink-0' onClick={onAction}>
      {action}
    </PillButton>
  </div>
);
